(function () {
  'use strict';
  /* quince.js build: 2026-10-02-no-express-misrep */

  /* Normalize stale trust / shipping copy — never claim Express / 1–2 day delivery */
  function qNormalizeTrustCopy() {
    var canonical = 'Free US shipping & 30-day returns on qualifying orders.';
    document.querySelectorAll('.q-home__hero-title, .q-announce__msg, .q-sticky-bar__trust').forEach(function (el) {
      var t = String(el.textContent || '').trim();
      var next = t;
      if (
        next.indexOf('365') !== -1 ||
        /PayPal\s*guest/i.test(next) ||
        /Card via PayPal/i.test(next) ||
        /Cards\s*&\s*PayPal/i.test(next) ||
        /Shipping (shown )?at checkout/i.test(next) ||
        /US Express rates before pay/i.test(next) ||
        /Free US Express/i.test(next) ||
        /JOB-SITE/i.test(next)
      ) {
        next = canonical;
      }
      if (next !== t) el.textContent = next;
    });
    document.querySelectorAll('.q-pdp__perk-text, .q-cart__shipping-free, .u-pdp__delivery-head span').forEach(function (el) {
      var t = String(el.textContent || '').trim();
      var next = t;
      if (
        /rates shown before|shown before (you )?pay/i.test(next) ||
        /US Express/i.test(next) ||
        /72\s*h(our)?/i.test(next) ||
        /1\s*[-–]\s*2\s*day/i.test(next)
      ) {
        next = /cart__shipping|shipping-free/i.test(el.className || '')
          ? 'Free US shipping'
          : /delivery-head/i.test((el.parentElement && el.parentElement.className) || '')
            ? 'Free US shipping — most orders 7–15 business days'
            : 'Free US shipping (7–15 business days after dispatch)';
      }
      if (next !== t) el.textContent = next;
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', qNormalizeTrustCopy);
  } else {
    qNormalizeTrustCopy();
  }

  var META_PIXEL_ID = '1507146397852103';

  function qLoadMetaPixel() {
    if (typeof window.fbq !== 'function') {
      var n = (window.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      });
      if (!window._fbq) window._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      var script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      var first = document.getElementsByTagName('script')[0];
      first.parentNode.insertBefore(script, first);
    }
    if (window.__velmorMetaPixelId === META_PIXEL_ID) return;
    window.fbq('init', META_PIXEL_ID);
    window.__velmorMetaPixelId = META_PIXEL_ID;
  }

  function qTrackMetaViewContent(variant, productTitle) {
    if (!variant || !variant.id) return;
    qLoadMetaPixel();
    if (typeof fbq !== 'function') return;
    fbq('track', 'ViewContent', {
      content_ids: [String(variant.id)],
      content_type: 'product',
      content_name: productTitle || '',
      value: qVariantPrice(variant),
      currency: qMetaCurrency()
    });
  }

  qLoadMetaPixel();

  function qMetaCurrency() {
    return (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
  }

  function qVariantPrice(variant) {
    if (!variant || variant.price == null) return 0;
    return Number(variant.price) / 100;
  }

  function qMetaEventId(prefix, variantId) {
    return String(prefix) + '-' + String(variantId) + '-' + Date.now();
  }

  function qPublishShopifyEvent(eventName, variant, productTitle, quantity) {
    var analytics = window.Shopify && window.Shopify.analytics;
    if (!analytics || typeof analytics.publish !== 'function' || !variant || !variant.id) return;
    var amount = qVariantPrice(variant);
    var qty = quantity || 1;
    try {
      analytics.publish(eventName, {
        cartLine: {
          cost: {
            totalAmount: {
              amount: amount * qty,
              currencyCode: qMetaCurrency()
            }
          },
          merchandise: {
            id: 'gid://shopify/ProductVariant/' + String(variant.id),
            product: { title: productTitle || '' },
            price: {
              amount: amount,
              currencyCode: qMetaCurrency()
            }
          },
          quantity: qty
        }
      });
    } catch (err) {
      /* Shopify web pixel bridge is optional */
    }
  }

  function qTrackMetaAddToCart(variant, productTitle, quantity) {
    if (!variant || !variant.id) return;
    try {
      qLoadMetaPixel();
      var eventId = qMetaEventId('atc', variant.id);
      var payload = {
        content_ids: [String(variant.id)],
        content_type: 'product',
        contents: [{ id: String(variant.id), quantity: quantity || 1 }],
        value: qVariantPrice(variant) * (quantity || 1),
        currency: qMetaCurrency()
      };
      if (productTitle) payload.content_name = productTitle;
      if (typeof fbq === 'function') {
        fbq('track', 'AddToCart', payload, { eventID: eventId });
      }
      qPublishShopifyEvent('product_added_to_cart', variant, productTitle, quantity || 1);
    } catch (err) {
      /* Tracking must never block add-to-cart / checkout */
    }
  }

  function qTrackMetaInitiateCheckout(variant, productTitle, quantity) {
    if (!variant || !variant.id) return;
    try {
      qLoadMetaPixel();
      var eventId = qMetaEventId('ic', variant.id);
      var payload = {
        content_ids: [String(variant.id)],
        content_type: 'product',
        contents: [{ id: String(variant.id), quantity: quantity || 1 }],
        value: qVariantPrice(variant) * (quantity || 1),
        currency: qMetaCurrency()
      };
      if (productTitle) payload.content_name = productTitle;
      if (typeof fbq === 'function') {
        fbq('track', 'InitiateCheckout', payload, { eventID: eventId });
      }
      qPublishShopifyEvent('checkout_started', variant, productTitle, quantity || 1);
    } catch (err) {
      /* Tracking must never block checkout */
    }
  }

  function qSleep(ms) {
    return new Promise(function (resolve) {
      window.setTimeout(resolve, ms);
    });
  }

  function qShouldRetryShopifyStatus(status) {
    /* Do not retry 429 — retries make Cloudflare rate-limits worse. */
    return status === 503 || status === 502 || status === 504;
  }

  function qShopifyFetch(url, options, retriesLeft) {
    /* quince-cart-retry.js already retries /cart/* — avoid nested storms. */
    var remaining =
      retriesLeft == null
        ? window.__qCartFetchPatch && String(url).indexOf('/cart/') !== -1
          ? 0
          : 1
        : retriesLeft;
    return fetch(url, options)
      .then(function (res) {
        if (qShouldRetryShopifyStatus(res.status) && remaining > 0) {
          return qSleep(1200).then(function () {
            return qShopifyFetch(url, options, remaining - 1);
          });
        }
        return res;
      })
      .catch(function (err) {
        if (remaining > 0) {
          return qSleep(1200).then(function () {
            return qShopifyFetch(url, options, remaining - 1);
          });
        }
        throw err;
      });
  }

  /* Announcement rotate */
  var announce = document.querySelector('[data-q-announce]');
  if (announce) {
    var msgs = announce.querySelectorAll('[data-q-announce-msg]');
    var idx = 0;
    function showMsg(i) {
      msgs.forEach(function (m, j) {
        m.classList.toggle('is-active', j === i);
      });
    }
    if (msgs.length > 1) {
      setInterval(function () {
        idx = (idx + 1) % msgs.length;
        showMsg(idx);
      }, 5000);
    }
  }

  /* Menu drawer */
  function bindDrawer(openSel, drawerSel, closeSel, opts) {
    opts = opts || {};
    var openBtn = document.querySelector(openSel);
    var drawer = document.querySelector(drawerSel);
    if (!openBtn || !drawer) return;

    function openDrawer() {
      drawer.hidden = false;
      if (opts.bodyClass) document.body.classList.add(opts.bodyClass);
    }

    function closeDrawer() {
      drawer.hidden = true;
      if (opts.bodyClass) document.body.classList.remove(opts.bodyClass);
    }

    openBtn.addEventListener('click', openDrawer);
    drawer.querySelectorAll(closeSel).forEach(function (el) {
      el.addEventListener('click', closeDrawer);
    });

    if (opts.onOpen) opts.onOpen(openDrawer, closeDrawer);
  }

  bindDrawer('[data-q-menu-open]', '[data-q-drawer]', '[data-q-drawer-close]', {
    bodyClass: 'q-drawer-open',
    onOpen: function (openDrawer, closeDrawer) {
      var searchFromDrawer = document.querySelector('[data-q-drawer-search-open]');
      var searchOpen = document.querySelector('[data-q-search-open]');
      if (searchFromDrawer && searchOpen) {
        searchFromDrawer.addEventListener('click', function () {
          closeDrawer();
          searchOpen.click();
        });
      }
    }
  });
  bindDrawer('[data-q-search-open]', '[data-q-search]', '[data-q-search-close]', {
    bodyClass: 'q-search-open',
    onOpen: function () {
      var input = document.querySelector('[data-q-search] input[type="search"]');
      if (input) {
        window.setTimeout(function () {
          input.focus();
        }, 50);
      }
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var search = document.querySelector('[data-q-search]');
    if (search && !search.hidden) {
      search.hidden = true;
      document.body.classList.remove('q-search-open');
    }
  });
  bindDrawer('[data-q-filter-open]', '[data-q-filter-drawer]', '[data-q-filter-close]');

  /* Inline filter dropdowns — fixed positioning avoids scroll/overflow clipping */
  (function initFilterDropdowns() {
    var filterRoot = document.querySelector('[data-q-filters]');
    if (!filterRoot) return;

    var triggers = filterRoot.querySelectorAll('[data-q-filter-dropdown-trigger]');
    var panels = filterRoot.querySelectorAll('[data-q-filter-dropdown-panel]');
    if (!triggers.length || !panels.length) return;

    panels.forEach(function (panel) {
      panel.addEventListener('click', function (event) {
        event.stopPropagation();
      });
    });

    function closeAllFilterDropdowns() {
      triggers.forEach(function (trigger) {
        trigger.setAttribute('aria-expanded', 'false');
      });
      panels.forEach(function (panel) {
        panel.hidden = true;
      });
    }

    function positionPanel(trigger, panel) {
      var rect = trigger.getBoundingClientRect();
      var isPrice = panel.hasAttribute('data-q-filter-panel-price');
      var panelWidth = isPrice ? 260 : Math.max(rect.width, 160);
      var left = rect.left;
      var maxLeft = window.innerWidth - panelWidth - 12;
      if (left > maxLeft) left = maxLeft;
      if (left < 12) left = 12;
      panel.style.top = rect.bottom + 4 + 'px';
      panel.style.left = left + 'px';
      panel.style.minWidth = panelWidth + 'px';
    }

    triggers.forEach(function (trigger, index) {
      trigger.addEventListener('click', function (event) {
        event.stopPropagation();
        var panel = panels[index];
        if (!panel) return;
        var willOpen = panel.hidden;
        closeAllFilterDropdowns();
        if (willOpen) {
          panel.hidden = false;
          trigger.setAttribute('aria-expanded', 'true');
          positionPanel(trigger, panel);
        }
      });
    });

    document.addEventListener('click', closeAllFilterDropdowns);
    window.addEventListener('resize', closeAllFilterDropdowns);
    window.addEventListener('scroll', closeAllFilterDropdowns, { passive: true });
  })();

  /* Price range filter — min/max inputs */
  (function initPriceFilters() {
    function parsePrice(value) {
      if (!value) return null;
      var num = parseFloat(String(value).replace(/,/g, ''));
      return isNaN(num) ? null : num;
    }

    function clampPriceInputs(form) {
      var minInput = form.querySelector('[data-q-price-min]');
      var maxInput = form.querySelector('[data-q-price-max]');
      if (!minInput || !maxInput) return;

      var minBound = parsePrice(minInput.getAttribute('data-min'));
      if (minBound === null) minBound = 0;
      var maxBound = parsePrice(maxInput.getAttribute('data-max'));
      var minVal = parsePrice(minInput.value);
      var maxVal = parsePrice(maxInput.value);

      if (minVal !== null) {
        if (minVal < minBound) minInput.value = String(minBound);
        if (maxBound !== null && minVal > maxBound) minInput.value = String(maxBound);
      }
      if (maxVal !== null) {
        if (maxBound !== null && maxVal > maxBound) maxInput.value = String(maxBound);
        if (minVal !== null && maxVal < minVal) maxInput.value = minInput.value;
      }
    }

    document.querySelectorAll('[data-q-price-filter]').forEach(function (form) {
      form.querySelectorAll('[data-q-price-min], [data-q-price-max]').forEach(function (input) {
        input.addEventListener('change', function () {
          clampPriceInputs(form);
        });
      });

      form.addEventListener('submit', function (event) {
        event.preventDefault();
        clampPriceInputs(form);
        var url = new URL(window.location.href);
        var minInput = form.querySelector('[data-q-price-min]');
        var maxInput = form.querySelector('[data-q-price-max]');

        if (minInput) {
          url.searchParams.delete(minInput.name);
          if (minInput.value.trim()) {
            url.searchParams.set(minInput.name, minInput.value.trim());
          }
        }
        if (maxInput) {
          url.searchParams.delete(maxInput.name);
          if (maxInput.value.trim()) {
            url.searchParams.set(maxInput.name, maxInput.value.trim());
          }
        }

        window.location.href = url.toString();
      });
    });
  })();

  /* Sort redirect */
  var sortSelect = document.querySelector('[data-q-sort]');
  if (sortSelect) {
    sortSelect.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortSelect.value);
      window.location.href = url.toString();
    });
  }

  /* PDP variant + sticky */
  var pdp = document.querySelector('[data-q-pdp]');
  if (pdp) {
    var jsonEl = document.querySelector('[data-q-product-json]');
    var product = jsonEl ? JSON.parse(jsonEl.textContent) : null;
    var form = document.getElementById('q-product-form');
    var variantInput = form && form.querySelector('[data-q-variant-id]');
    if (product && product.variants && product.variants.length) {
      var initialVariant = product.variants.find(function (v) {
        return variantInput && String(v.id) === String(variantInput.value);
      }) || product.variants[0];
      qTrackMetaViewContent(initialVariant, product.title);
    }
    var atcInline = form && form.querySelector('[data-q-atc]');
    var buyNowInline = form && form.querySelector('[data-q-buy-now]');
    var actionsEl = form && form.querySelector('.q-pdp__actions');
    var stickyTarget = actionsEl || atcInline;
    var stickyBar = document.querySelector('[data-q-sticky]');
    var stickyBtn = document.querySelector('[data-q-sticky-add]');
    var priceEl = document.querySelector('[data-q-price]');
    var compareEl = document.querySelector('[data-q-compare]');
    var saveEl = document.querySelector('[data-q-save]');
    var compareCol = document.querySelector('[data-q-price-compare-col]');
    var stickyPrice = document.querySelector('[data-q-sticky-price]');
    var stickySave = document.querySelector('[data-q-sticky-save]');
    var mobileStickyMq = window.matchMedia('(max-width: 749px)');
    var addToBagLabel = 'ADD TO BAG';
    var buyNowLabel = 'BUY NOW';
    var soldOutLabel = 'SOLD OUT';
    var checkoutBusy = false;

    function isInlineActionsVisible() {
      var el = buyNowInline || atcInline || stickyTarget;
      if (!el) return false;
      var rect = el.getBoundingClientRect();
      var vh = window.innerHeight || document.documentElement.clientHeight;
      var stickyReserve = 96;
      if (stickyBar && !stickyBar.classList.contains('is-suppressed')) {
        stickyReserve = Math.max(stickyBar.offsetHeight || 0, 96);
      }
      var headerReserve = 56;
      /* Only hide sticky when the inline CTA is fully usable (not just peeking in) */
      var visibleTop = Math.max(rect.top, headerReserve);
      var visibleBottom = Math.min(rect.bottom, vh - stickyReserve);
      var visibleHeight = visibleBottom - visibleTop;
      if (visibleHeight <= 0) return false;
      var needed = Math.min(Math.max(rect.height, 44), 120);
      return visibleHeight >= needed;
    }

    function setStickyVisible(show) {
      if (!stickyBar || !mobileStickyMq.matches) return;
      stickyBar.hidden = false;
      stickyBar.classList.toggle('is-suppressed', !show);
      document.body.classList.toggle('q-has-sticky', show);
    }

    function syncStickyVisibility() {
      if (!stickyBar) return;
      if (!mobileStickyMq.matches) {
        stickyBar.classList.remove('is-suppressed');
        document.body.classList.remove('q-has-sticky');
        return;
      }
      stickyBar.hidden = false;
      setStickyVisible(!isInlineActionsVisible());
    }

    function formatMoney(cents) {
      return '$' + (cents / 100).toFixed(2);
    }

    function setActionButtons(variant) {
      var available = variant && variant.available;
      if (atcInline) {
        atcInline.textContent = available ? addToBagLabel : soldOutLabel;
        atcInline.disabled = !available || checkoutBusy;
      }
      if (buyNowInline) {
        buyNowInline.textContent = available ? buyNowLabel : soldOutLabel;
        buyNowInline.disabled = !available || checkoutBusy;
      }
      if (stickyBtn) {
        stickyBtn.disabled = !available || checkoutBusy;
      }
    }

    function resolveVariant() {
      var variant = findVariant();
      if (variant) return variant;
      if (!variantInput || !product) return null;
      var id = parseInt(variantInput.value, 10);
      if (!id) return null;
      for (var i = 0; i < product.variants.length; i++) {
        if (product.variants[i].id === id) return product.variants[i];
      }
      return { id: id, price: 0 };
    }

    function goToCheckout(trigger) {
      if (checkoutBusy || !variantInput) return;
      var variantId = parseInt(variantInput.value, 10);
      if (!variantId) return;
      if (trigger && trigger.disabled) return;

      var variant = resolveVariant();
      var productTitle = product && product.title;
      checkoutBusy = true;
      var buyButtons = [buyNowInline, stickyBtn].filter(Boolean);
      var prevStickyHtml = stickyBtn ? stickyBtn.innerHTML : '';
      var prevBuyNowLabel = buyNowInline ? buyNowInline.textContent : '';
      buyButtons.forEach(function (btn) {
        btn.disabled = true;
        btn.textContent = 'Processing…';
      });
      if (atcInline) atcInline.disabled = true;

      function restoreCheckoutButtons() {
        checkoutBusy = false;
        if (stickyBtn) stickyBtn.innerHTML = prevStickyHtml;
        if (buyNowInline) buyNowInline.textContent = prevBuyNowLabel || buyNowLabel;
        if (atcInline) atcInline.disabled = false;
        var current = findVariant();
        if (current) {
          setActionButtons(current);
        } else {
          buyButtons.forEach(function (btn) {
            btn.disabled = false;
          });
        }
      }

      /*
        Buy Now: add selected variant → checkout, keep existing cart lines.
        Full-page redirect only (no Ajax /cart/*.js) to avoid Cloudflare 429.
        Do NOT /cart/clear — that wiped other line items before checkout.
      */
      try {
        qTrackMetaAddToCart(variant, productTitle);
        var qtyEl = form && form.querySelector('[name="quantity"]');
        var qty = qtyEl ? parseInt(qtyEl.value, 10) : 1;
        if (!qty || qty < 1) qty = 1;
        window.location.assign(
          '/cart/' + String(variantId) + ':' + String(qty) + '?checkout'
        );
      } catch (err) {
        restoreCheckoutButtons();
        alert('Unable to start checkout. Please try again.');
      }
    }

    function findVariant() {
      if (!product) return null;
      var selected = {};
      pdp.querySelectorAll('[data-q-option-input]:checked').forEach(function (input) {
        var name = input.name.replace('options[', '').replace(']', '');
        selected[name] = input.value;
      });
      return product.variants.find(function (v) {
        return v.options.every(function (opt, i) {
          var key = product.options[i];
          return selected[key] === opt;
        });
      });
    }

    function updateOptionLegends() {
      pdp.querySelectorAll('.q-pdp__option').forEach(function (fieldset) {
        var checked = fieldset.querySelector('[data-q-option-input]:checked');
        var selectedEl = fieldset.querySelector('[data-q-option-selected]');
        if (checked && selectedEl) {
          selectedEl.textContent = checked.value;
        }
      });
    }

    function updateVariant() {
      var variant = findVariant();
      if (!variant) return;
      if (variantInput) variantInput.value = variant.id;
      setActionButtons(variant);
      if (stickyBtn && stickyPrice) stickyPrice.textContent = formatMoney(variant.price);
      if (priceEl) priceEl.textContent = formatMoney(variant.price);
      var hasCompare = variant.compare_at_price && variant.compare_at_price > variant.price;
      if (compareCol) compareCol.hidden = !hasCompare;
      if (saveEl) saveEl.hidden = !hasCompare;
      if (compareEl && hasCompare) {
        compareEl.textContent = formatMoney(variant.compare_at_price);
      }
      if (saveEl && hasCompare) {
        var pct = Math.round(((variant.compare_at_price - variant.price) / variant.compare_at_price) * 100);
        saveEl.textContent = 'You save ' + pct + '%';
        if (stickySave) {
          stickySave.textContent = ' · You save ' + pct + '%';
          stickySave.hidden = false;
        }
      } else if (stickySave) {
        stickySave.hidden = true;
      }
    }

    pdp.querySelectorAll('[data-q-option-input]').forEach(function (input) {
      input.addEventListener('change', function () {
        updateOptionLegends();
        updateVariant();
      });
    });

    if (form) {
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        if (checkoutBusy) return;
        var variant = resolveVariant();
        if (!variant || !variant.available) return;

        checkoutBusy = true;
        if (atcInline) {
          atcInline.disabled = true;
          atcInline.textContent = 'Adding…';
        }
        if (buyNowInline) buyNowInline.disabled = true;

        qShopifyFetch('/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: variant.id, quantity: 1 }] })
        })
          .then(function (res) {
            if (!res.ok) throw new Error('add failed');
            qTrackMetaAddToCart(variant, product && product.title);
            window.setTimeout(function () {
              window.location.href = '/cart';
            }, 200);
          })
          .catch(function () {
            checkoutBusy = false;
            if (atcInline) {
              atcInline.disabled = false;
              atcInline.textContent = addToBagLabel;
            }
            if (buyNowInline) buyNowInline.disabled = false;
            var current = findVariant();
            if (current) setActionButtons(current);
            alert('Unable to add to bag. Please try again.');
          });
      });
    }

    if (buyNowInline) {
      buyNowInline.addEventListener('click', function () {
        goToCheckout(buyNowInline);
      });
    }

    if (stickyBtn) {
      stickyBtn.addEventListener('click', function () {
        goToCheckout(stickyBtn);
      });
    }

    if (stickyBar) {
      stickyBar.hidden = false;
      syncStickyVisibility();
      if (stickyTarget) {
        var atcObserver = new IntersectionObserver(
          function () {
            syncStickyVisibility();
          },
          { threshold: [0, 0.01, 0.25, 0.5, 1], rootMargin: '0px 0px -104px 0px' }
        );
        atcObserver.observe(stickyTarget);
      }
      window.addEventListener('scroll', syncStickyVisibility, { passive: true });
      window.addEventListener('resize', syncStickyVisibility);
      window.addEventListener('orientationchange', syncStickyVisibility);
      window.addEventListener('load', syncStickyVisibility);
      requestAnimationFrame(syncStickyVisibility);
    }

    mobileStickyMq.addEventListener('change', function () {
      syncStickyVisibility();
    });

    /* PDP gallery — Strathberry-style full-width + dots + infinite loop */
    var gallery = pdp.querySelector('[data-q-gallery]');
    if (gallery) {
      var track = gallery.querySelector('[data-q-gallery-track]');
      var realSlides = gallery.querySelectorAll('[data-q-slide]');
      var dots = gallery.querySelectorAll('[data-q-gallery-dot]');
      var scrollTicking = false;
      var autoplayTimer = null;
      var looping = false;
      var totalSlides = realSlides.length;
      var allSlides = realSlides;
      var hasInfiniteClones = false;
      var galleryDesktopMq = window.matchMedia('(min-width: 750px)');

      function isDesktopGallery() {
        return galleryDesktopMq.matches;
      }

      function getActiveDotIndex() {
        var activeIdx = 0;
        dots.forEach(function (dot, i) {
          if (dot.classList.contains('is-active')) activeIdx = i;
        });
        return activeIdx;
      }

      function teardownInfiniteLoop() {
        if (!hasInfiniteClones || !track) return;
        track.querySelectorAll('[data-q-slide-clone]').forEach(function (el) {
          el.remove();
        });
        allSlides = realSlides;
        hasInfiniteClones = false;
      }

      function setActiveDot(index) {
        var safeIndex = ((index % totalSlides) + totalSlides) % totalSlides;
        dots.forEach(function (dot, i) {
          var active = i === safeIndex;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-selected', active ? 'true' : 'false');
        });
      }

      function getTrackSlideWidth() {
        return track ? track.clientWidth : 0;
      }

      function getSlideScrollLeft(index) {
        if (!track || !allSlides[index]) return 0;
        return allSlides[index].offsetLeft;
      }

      function getScrollIndex() {
        if (!track || !allSlides.length) return 1;
        var w = getTrackSlideWidth();
        if (!w) return 1;
        return Math.round(track.scrollLeft / w);
      }

      function scrollToIndex(index, behavior) {
        if (!track || !allSlides[index]) return;
        var left = getSlideScrollLeft(index);
        if (!behavior || behavior === 'auto') {
          jumpWithoutSnap(index);
          return;
        }
        looping = true;
        track.style.scrollSnapType = 'none';
        track.scrollTo({ left: left, behavior: behavior });
        clearTimeout(scrollToIndex._timer);
        scrollToIndex._timer = setTimeout(function () {
          track.style.scrollSnapType = '';
          looping = false;
        }, 450);
      }

      function jumpWithoutSnap(index) {
        if (!track || !allSlides[index]) return;
        looping = true;
        track.style.scrollSnapType = 'none';
        track.scrollLeft = getSlideScrollLeft(index);
        track.style.scrollSnapType = '';
        requestAnimationFrame(function () {
          looping = false;
        });
      }

      function checkLoop() {
        if (looping || totalSlides < 2 || isDesktopGallery()) return;
        var idx = getScrollIndex();
        if (idx === 0) {
          jumpWithoutSnap(totalSlides);
          setActiveDot(totalSlides - 1);
        } else if (idx === totalSlides + 1) {
          jumpWithoutSnap(1);
          setActiveDot(0);
        } else if (idx >= 1 && idx <= totalSlides) {
          setActiveDot(idx - 1);
        }
      }

      function goToSlide(realIndex, behavior) {
        if (totalSlides < 2) return;
        var scrollIndex = isDesktopGallery() ? realIndex : realIndex + 1;
        scrollToIndex(scrollIndex, behavior);
        setActiveDot(realIndex);
      }

      function setupInfiniteLoop() {
        if (totalSlides < 2 || !track) return;

        if (isDesktopGallery()) {
          teardownInfiniteLoop();
          allSlides = realSlides;
          jumpWithoutSnap(getActiveDotIndex());
          setActiveDot(getActiveDotIndex());
          return;
        }

        if (hasInfiniteClones) return;

        var firstClone = realSlides[0].cloneNode(true);
        var lastClone = realSlides[totalSlides - 1].cloneNode(true);
        firstClone.setAttribute('data-q-slide-clone', 'first');
        lastClone.setAttribute('data-q-slide-clone', 'last');
        firstClone.removeAttribute('id');
        lastClone.removeAttribute('id');

        track.insertBefore(lastClone, realSlides[0]);
        track.appendChild(firstClone);
        allSlides = track.querySelectorAll('.q-pdp__slide');
        hasInfiniteClones = true;

        jumpWithoutSnap(getActiveDotIndex() + 1);
        setActiveDot(getActiveDotIndex());
      }

      function syncGalleryLayout() {
        if (!track || totalSlides < 2) return;
        requestAnimationFrame(function () {
          goToSlide(getActiveDotIndex(), 'auto');
        });
      }

      function stopAutoplay() {
        if (autoplayTimer) {
          clearInterval(autoplayTimer);
          autoplayTimer = null;
        }
      }

      function startAutoplay() {
        if (totalSlides < 2 || window.matchMedia('(min-width: 750px)').matches) return;
        stopAutoplay();
        autoplayTimer = setInterval(function () {
          var idx = getScrollIndex();
          var realIndex = idx - 1;
          if (idx === 0) realIndex = totalSlides - 1;
          if (idx === totalSlides + 1) realIndex = 0;

          if (realIndex === totalSlides - 1) {
            scrollToIndex(totalSlides + 1, 'smooth');
          } else {
            goToSlide(realIndex + 1, 'smooth');
          }
        }, 4000);
      }

      function onGalleryScroll() {
        if (scrollTicking || looping) return;
        scrollTicking = true;
        requestAnimationFrame(function () {
          var idx = getScrollIndex();
          if (isDesktopGallery()) {
            if (idx >= 0 && idx < totalSlides) setActiveDot(idx);
          } else if (idx >= 1 && idx <= totalSlides) {
            setActiveDot(idx - 1);
          }
          scrollTicking = false;
        });
      }

      var scrollEndTimer;
      function onGalleryScrollEnd() {
        clearTimeout(scrollEndTimer);
        scrollEndTimer = setTimeout(checkLoop, 80);
      }

      if (track) {
        track.addEventListener('scroll', onGalleryScroll, { passive: true });
        track.addEventListener('scroll', onGalleryScrollEnd, { passive: true });
        if ('onscrollend' in track) {
          track.addEventListener('scrollend', checkLoop, { passive: true });
        }
      }

      dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          var idx = parseInt(dot.getAttribute('data-q-gallery-dot'), 10);
          goToSlide(idx, isDesktopGallery() ? 'auto' : 'smooth');
        });
      });

      /* Image lightbox — swipeable like Strathberry */
      var lightbox = pdp.querySelector('[data-q-lightbox]');
      var lbTrack = lightbox && lightbox.querySelector('[data-q-lightbox-track]');
      var lbSlides = lbTrack ? lbTrack.querySelectorAll('[data-q-lightbox-slide]') : [];
      var lbCounter = lightbox && lightbox.querySelector('[data-q-lightbox-counter]');
      var lbPrev = lightbox && lightbox.querySelector('[data-q-lightbox-prev]');
      var lbNext = lightbox && lightbox.querySelector('[data-q-lightbox-next]');
      var lbTotal = lbSlides.length;
      var lastFocus = null;
      var lbScrollTicking = false;

      function getLbIndex() {
        if (!lbTrack || !lbSlides.length) return 0;
        var w = lbTrack.offsetWidth;
        if (!w) return 0;
        return Math.max(0, Math.min(lbSlides.length - 1, Math.round(lbTrack.scrollLeft / w)));
      }

      function updateLbCounter(index) {
        if (lbCounter && lbTotal > 0) {
          lbCounter.textContent = (index + 1) + ' of ' + lbTotal;
        }
      }

      function scrollLbTo(index, behavior) {
        if (!lbTrack || !lbSlides[index]) return;
        lbTrack.scrollTo({ left: lbSlides[index].offsetLeft, behavior: behavior || 'smooth' });
        updateLbCounter(index);
      }

      function openLightbox(zoomIndex) {
        if (!lightbox || !lbTrack || lbTotal === 0) return;
        stopAutoplay();
        lastFocus = document.activeElement;
        var idx = Math.max(0, Math.min(lbTotal - 1, parseInt(zoomIndex, 10) || 0));
        lightbox.hidden = false;
        lightbox.setAttribute('aria-hidden', 'false');
        document.body.classList.add('q-lightbox-open');
        scrollLbTo(idx, 'auto');
        var closeBtn = lightbox.querySelector('[data-q-lightbox-close]');
        if (closeBtn) closeBtn.focus();
      }

      function closeLightbox() {
        if (!lightbox) return;
        var lbIndex = getLbIndex();
        var lbSlide = lbSlides[lbIndex];
        var mediaIndex = lbSlide && lbSlide.getAttribute('data-q-media-index');
        lightbox.hidden = true;
        lightbox.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('q-lightbox-open');
        if (mediaIndex !== null && totalSlides > 1) {
          goToSlide(parseInt(mediaIndex, 10), 'auto');
        }
        if (lastFocus && lastFocus.focus) lastFocus.focus();
        startAutoplay();
      }

      function onLbScroll() {
        if (lbScrollTicking) return;
        lbScrollTicking = true;
        requestAnimationFrame(function () {
          updateLbCounter(getLbIndex());
          lbScrollTicking = false;
        });
      }

      if (track && lightbox && lbTrack) {
        track.addEventListener('click', function (e) {
          var media = e.target.closest('.q-pdp__slide-media--zoomable');
          if (!media) return;
          var zoomIndex = media.getAttribute('data-q-zoom-index');
          openLightbox(zoomIndex);
        });

        lightbox.querySelectorAll('[data-q-lightbox-close]').forEach(function (el) {
          el.addEventListener('click', closeLightbox);
        });

        if (lbPrev) {
          lbPrev.addEventListener('click', function () {
            var idx = getLbIndex();
            if (idx > 0) scrollLbTo(idx - 1, 'smooth');
          });
        }

        if (lbNext) {
          lbNext.addEventListener('click', function () {
            var idx = getLbIndex();
            if (idx < lbTotal - 1) scrollLbTo(idx + 1, 'smooth');
          });
        }

        lbTrack.addEventListener('scroll', onLbScroll, { passive: true });

        document.addEventListener('keydown', function (e) {
          if (lightbox.hidden) return;
          if (e.key === 'Escape') closeLightbox();
          if (e.key === 'ArrowLeft' && lbPrev) scrollLbTo(getLbIndex() - 1, 'smooth');
          if (e.key === 'ArrowRight' && lbNext) scrollLbTo(getLbIndex() + 1, 'smooth');
        });
      }

      setupInfiniteLoop();
      startAutoplay();
      window.addEventListener('load', syncGalleryLayout);
      galleryDesktopMq.addEventListener('change', function () {
        setupInfiniteLoop();
        syncGalleryLayout();
        if (isDesktopGallery()) stopAutoplay();
        else startAutoplay();
      });

      window.addEventListener('resize', function () {
        if (totalSlides < 2) return;
        if (!isDesktopGallery()) {
          var idx = getScrollIndex();
          if (idx < 1 || idx > totalSlides) {
            var real = idx === 0 ? totalSlides - 1 : 0;
            jumpWithoutSnap(real + 1);
            setActiveDot(real);
          }
        }
        syncGalleryLayout();
        if (isDesktopGallery()) stopAutoplay();
        else startAutoplay();
      });
    }
  }

  /* Product card — swatch click switches main image + price */
  document.addEventListener('click', function (event) {
    var swatch = event.target.closest('[data-q-card-swatch]');
    if (!swatch) return;
    if (!swatch.dataset.imageUrl && !swatch.dataset.price) return;
    event.preventDefault();
    event.stopPropagation();
    var card = swatch.closest('[data-q-card]');
    if (!card) return;

    if (swatch.dataset.imageUrl) {
      var img = card.querySelector('.q-card__img');
      if (img) {
        var url600 = swatch.dataset.imageUrl;
        var url352 = swatch.dataset.imageUrl352 || url600.replace('width=600', 'width=352');
        img.src = url600;
        img.srcset = url352 + ' 352w, ' + url600 + ' 600w';
      }
      var wishBtn = card.querySelector('[data-q-wish]');
      if (wishBtn) {
        wishBtn.dataset.productImage = swatch.dataset.imageUrl;
      }
    }

    if (swatch.dataset.price) {
      var priceText = card.querySelector('[data-q-card-price-text]');
      if (priceText) {
        priceText.textContent = swatch.dataset.price;
      }
      var wishBtnPrice = card.querySelector('[data-q-wish]');
      if (wishBtnPrice) {
        wishBtnPrice.dataset.productPrice = swatch.dataset.price;
      }
    }

    card.querySelectorAll('[data-q-card-swatch]').forEach(function (btn) {
      var active = btn === swatch;
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  });

  function mergePlpFetchHtml(plp, html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var newGrid = doc.querySelector('[data-q-plp-grid]');
    var grid = plp.querySelector('[data-q-plp-grid]');
    if (newGrid && grid) {
      grid.innerHTML = newGrid.innerHTML;
    }
    var newSentinel = doc.querySelector('[data-q-infinite-sentinel]');
    var sentinel = plp.querySelector('[data-q-infinite-sentinel]');
    if (sentinel && newSentinel && newSentinel.dataset.nextUrl) {
      sentinel.dataset.nextUrl = newSentinel.dataset.nextUrl;
    } else if (sentinel && (!newSentinel || !newSentinel.dataset.nextUrl)) {
      sentinel.remove();
    } else if (!sentinel && newSentinel && newSentinel.dataset.nextUrl) {
      plp.appendChild(newSentinel.cloneNode(true));
    }
    if (window.qSyncWishButtons) window.qSyncWishButtons();
    if (window.qInitEzReviewStars) window.qInitEzReviewStars();
  }

  function bootstrapPlpFromCollection(plp) {
    var fetchBase = plp.dataset.qPlpFetch;
    var sectionId = plp.dataset.sectionId;
    if (!fetchBase || !sectionId) return Promise.resolve();
    var url = fetchBase + '&section_id=' + encodeURIComponent(sectionId) + '&page=1';
    return fetch(url)
      .then(function (res) {
        if (!res.ok) throw new Error('bootstrap failed');
        return res.text();
      })
      .then(function (html) {
        mergePlpFetchHtml(plp, html);
      })
      .catch(function () {});
  }

  function initPlpInfiniteScroll(plp) {
    var grid = plp.querySelector('[data-q-plp-grid]');
    var sentinel = plp.querySelector('[data-q-infinite-sentinel]');
    var sectionId = plp.dataset.sectionId;
    var loading = false;

    if (!grid || !sentinel || !sectionId) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting || loading) return;
          var nextUrl = sentinel.dataset.nextUrl;
          if (!nextUrl) return;

          loading = true;
          sentinel.classList.add('is-loading');

          var url = new URL(nextUrl, window.location.origin);
          url.searchParams.set('section_id', sectionId);

          fetch(url.toString())
            .then(function (res) {
              if (!res.ok) throw new Error('load failed');
              return res.text();
            })
            .then(function (html) {
              var doc = new DOMParser().parseFromString(html, 'text/html');
              var newGrid = doc.querySelector('[data-q-plp-grid]');
              if (newGrid) {
                newGrid.querySelectorAll('.q-card').forEach(function (card) {
                  grid.appendChild(card);
                });
                if (window.qSyncWishButtons) window.qSyncWishButtons();
                if (window.qInitEzReviewStars) window.qInitEzReviewStars();
              }
              var newSentinel = doc.querySelector('[data-q-infinite-sentinel]');
              if (newSentinel && newSentinel.dataset.nextUrl) {
                sentinel.dataset.nextUrl = newSentinel.dataset.nextUrl;
              } else {
                observer.disconnect();
                sentinel.remove();
              }
            })
            .catch(function () {
              observer.disconnect();
            })
            .finally(function () {
              loading = false;
              if (sentinel.parentNode) {
                sentinel.classList.remove('is-loading');
              }
            });
        });
      },
      { rootMargin: '600px 0px' }
    );

    observer.observe(sentinel);
  }

  /* PLP infinite scroll + homepage bootstrap (newest-first via collection fetch) */
  document.querySelectorAll('[data-q-plp-fetch]').forEach(function (plp) {
    bootstrapPlpFromCollection(plp).finally(function () {
      initPlpInfiniteScroll(plp);
    });
  });
  document.querySelectorAll('[data-q-plp]:not([data-q-plp-fetch])').forEach(initPlpInfiniteScroll);

  /* EZ Amazon Reviews Importer — Quince-style ★ 4.8 on PLP/PDP when review data exists */
  function extractEzRatingValue(el) {
    var root = el;
    if (el.nextElementSibling && el.nextElementSibling.classList.contains('rev-titl-wp')) {
      root = el.nextElementSibling;
    }
    var numEl = root.querySelector('.nub-rev-tt, .avg-rate, .ez-modern-score-big, [class*="average"]');
    if (numEl) {
      var numMatch = (numEl.textContent || '').match(/(\d+\.\d|\d+)/);
      if (numMatch) return parseFloat(numMatch[1]);
    }
    var textMatch = (root.textContent || '').match(/(\d+\.\d)/);
    return textMatch ? parseFloat(textMatch[1]) : null;
  }

  function normalizeEzRating(el) {
    if (el.classList.contains('q-rating--ez-normalized')) return;
    var value = extractEzRatingValue(el);
    if (!value || value <= 0) return;
    var display = (Math.round(value * 10) / 10).toFixed(1);
    var isCard = el.classList.contains('jstar-under-title-list');
    el.innerHTML =
      '<svg class="q-rating__icon" width="12" height="12" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M12 2l3.1 6.3 6.9 1-5 4.9 1.2 6.9L12 17.8 5.8 21l1.2-6.9-5-4.9 6.9-1z"/></svg>' +
      '<span class="q-rating__value">' +
      display +
      '</span>';
    el.classList.add(isCard ? 'q-rating--card' : 'q-rating--pdp', 'q-rating--ez-normalized');
    el.setAttribute('aria-label', 'Rated ' + display + ' out of 5');
  }

  function markEzRatingReady(el) {
    if (!el || el.classList.contains('q-rating--ez-ready')) return;
    var hasInner = el.innerHTML.trim().length > 0;
    var hasNextRev = el.nextElementSibling && el.nextElementSibling.classList.contains('rev-titl-wp');
    var hasInnerRev = !!el.querySelector('.rev-titl-wp, .nub-rev-tt, .dark-str-i, .fx-star-under-title-list');
    if (!hasInner && !hasNextRev && !hasInnerRev) return;
    normalizeEzRating(el);
    if (hasInner || hasInnerRev) {
      el.classList.add('q-rating--ez-ready');
    }
    if (hasNextRev) {
      el.nextElementSibling.classList.add('q-rating--ez-ready');
    }
  }

  function initEzReviewStars() {
    document.querySelectorAll('.jstar-under-pd-title, .jstar-under-title-list').forEach(markEzRatingReady);
  }

  function fetchEzCollectionRatings() {
    var placeholders = document.querySelectorAll('.jstar-under-title-list[data-product-id]:not(.q-rating--ez-ready)');
    if (!placeholders.length || !window.Shopify || !Shopify.shop) return;

    var productIds = [];
    placeholders.forEach(function (el) {
      var id = el.getAttribute('data-product-id');
      if (id) productIds.push(id);
    });
    if (!productIds.length) return;

    var body = new URLSearchParams();
    productIds.forEach(function (id) {
      body.append('productIds[]', id);
    });
    body.append('storeUrl', window.location.href);

    fetch('https://dev.younet.network/importreview/ajaxStarUnderProductList?shop=' + Shopify.shop, {
      method: 'POST',
      body: body,
    })
      .then(function (res) {
        return res.text();
      })
      .then(function (text) {
        text = (text || '').trim();
        if (!text || text === '[]') return;
        var productStars = JSON.parse(text);
        Object.keys(productStars).forEach(function (productId) {
          var el = document.querySelector('.jstar-under-title-list[data-product-id="' + productId + '"]');
          if (!el || !productStars[productId] || !productStars[productId].content) return;
          el.innerHTML = productStars[productId].content;
          markEzRatingReady(el);
        });
      })
      .catch(function () {});
  }

  function observeEzReviewStars() {
    if (window.__qEzRatingObserver) return;
    window.__qEzRatingObserver = new MutationObserver(function () {
      initEzReviewStars();
    });
    document.querySelectorAll('.jstar-under-pd-title, .jstar-under-title-list').forEach(function (el) {
      window.__qEzRatingObserver.observe(el, { childList: true, subtree: true, characterData: true });
    });
  }

  window.qInitEzReviewStars = initEzReviewStars;
  window.addEventListener('load', function () {
    initEzReviewStars();
    fetchEzCollectionRatings();
    setTimeout(initEzReviewStars, 800);
    setTimeout(fetchEzCollectionRatings, 1200);
  });
  observeEzReviewStars();

  /* EZ Amazon Reviews Importer — hide sort dropdown only */
  function hideEzReviewSort() {
    document.querySelectorAll('#sort_review').forEach(function (el) {
      el.setAttribute('hidden', '');
      el.setAttribute('aria-hidden', 'true');
      el.style.setProperty('display', 'none', 'important');
    });
  }

  function ensurePdpDescriptionStyles() {
    if (!document.querySelector('.q-pdp__description')) return;
    if (document.getElementById('q-pdp-desc-divider-fix')) return;

    var style = document.createElement('style');
    style.id = 'q-pdp-desc-divider-fix';
    style.textContent =
      '.q-pdp__info .q-pdp__description{border-top:1px solid rgba(33,32,31,.08)!important;padding-top:1.5rem!important}' +
      '.q-pdp__info .q-pdp-reviews:not(.q-pdp-reviews--has-reviews){display:none!important;height:0!important;margin:0!important;padding:0!important;overflow:hidden!important}' +
      'body.q-template-product .ez-amrv-wrapp:has(#ez_review_containter[data-review="0"]){display:none!important;height:0!important;margin:0!important;padding:0!important;overflow:hidden!important}';
    document.head.appendChild(style);
  }

  function styleEzReviewUi() {
    ensurePdpDescriptionStyles();
    hideEzReviewSort();
    syncReviewsSectionVisibility();
    runPdpDescriptionEnhancements();

    var loadBtn = document.getElementById('realoadMore');
    if (loadBtn) {
      var label = (loadBtn.textContent || '').replace(/\s+/g, ' ').trim();
      if (!label || label === '. . .' || label === '...') {
        loadBtn.textContent = 'LOAD MORE REVIEWS';
      }
      loadBtn.setAttribute('aria-label', 'Load more reviews');
    }
  }

  window.qHideEzReviewSort = hideEzReviewSort;
  window.qStyleEzReviewUi = styleEzReviewUi;
  document.addEventListener('DOMContentLoaded', function () {
    ensurePdpDescriptionStyles();
    styleEzReviewUi();
    runPdpDescriptionEnhancements();
  });
  window.addEventListener('load', function () {
    ensurePdpDescriptionStyles();
    styleEzReviewUi();
    runPdpDescriptionEnhancements();
  });

  function syncReviewsSectionVisibility() {
    var section = document.querySelector('.q-pdp-reviews');
    if (!section) return;

    var container = document.getElementById('ez_review_containter');
    var reviewCountRaw = container ? container.getAttribute('data-review') : null;
    var reviewCount =
      reviewCountRaw !== null && reviewCountRaw !== '' ? parseInt(reviewCountRaw, 10) : null;

    var hasReviews = reviewCount !== null && !isNaN(reviewCount) && reviewCount > 0;

    if (hasReviews) {
      section.classList.add('q-pdp-reviews--has-reviews');
      section.classList.remove('q-pdp-reviews--empty');
      section.removeAttribute('hidden');
    } else if (reviewCount === 0) {
      section.classList.add('q-pdp-reviews--empty');
      section.classList.remove('q-pdp-reviews--has-reviews');
      section.setAttribute('hidden', '');
    } else {
      var wrapper = document.getElementById('aliexpress-review-wrapper-sp');
      var wrapperLoaded = wrapper && wrapper.innerHTML.trim().length > 0;
      if (!wrapperLoaded) return;

      section.classList.add('q-pdp-reviews--empty');
      section.classList.remove('q-pdp-reviews--has-reviews');
      section.setAttribute('hidden', '');
    }

    document.querySelectorAll('.ez-amrv-wrapp, #ra-dt-wrpp').forEach(function (widget) {
      var ezContainer = widget.querySelector('#ez_review_containter') || widget;
      var countRaw = ezContainer.getAttribute('data-review');
      var count = countRaw !== null && countRaw !== '' ? parseInt(countRaw, 10) : null;
      if (count === 0) {
        widget.setAttribute('hidden', '');
        widget.style.setProperty('display', 'none', 'important');
        widget.style.setProperty('height', '0', 'important');
        widget.style.setProperty('margin', '0', 'important');
        widget.style.setProperty('padding', '0', 'important');
      }
    });
  }

  function collapseEmptyDescriptionBlocks() {
    var description = document.querySelector('.q-pdp__description');
    if (!description) return;

    var selectors =
      'h1, h2, h3, h4, p, div.detailmodule_html, div.detail-desc-decorate-richtext, span.slate-node-text';
    var changed = true;
    var passes = 0;

    while (changed && passes < 8) {
      changed = false;
      passes += 1;
      description.querySelectorAll(selectors).forEach(function (el) {
        if (el.closest('.q-pdp__description') !== description && !description.contains(el)) return;
        var text = (el.textContent || '').replace(/\u00a0/g, ' ').replace(/\s+/g, '').trim();
        var hasMedia = el.querySelector('img, video, iframe, svg, picture, table');
        if (!text && !hasMedia && el.parentNode) {
          el.parentNode.removeChild(el);
          changed = true;
        }
      });
    }
  }

  function titleCaseLabel(str) {
    return String(str || '')
      .toLowerCase()
      .replace(/(?:^|\s|[-/])\w/g, function (ch) {
        return ch.toUpperCase();
      });
  }

  function cleanMarketingText(text) {
    return String(text || '')
      .replace(/[\u{1F300}-\u{1F9FF}]/gu, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function formatFeatureValue(value) {
    value = cleanMarketingText(value);
    if (/\d+%:\s/.test(value)) {
      var parts = value.split(/(?=\d+%:\s)/);
      if (parts.length >= 2) {
        var items = parts
          .map(function (part) {
            var match = part.match(/^(\d+%):\s*(.+)$/);
            if (match) {
              return (
                '<li><strong>' +
                escapeDescHtml(match[1]) +
                '</strong> ' +
                escapeDescHtml(match[2].trim()) +
                '</li>'
              );
            }
            return part.trim() ? '<li>' + escapeDescHtml(part.trim()) + '</li>' : '';
          })
          .filter(Boolean)
          .join('');
        if (items) {
          return '<ul class="q-pdp-feature-card__list">' + items + '</ul>';
        }
      }
    }
    return escapeDescHtml(value);
  }

  function stripInlineBrackets(text) {
    return cleanMarketingText(text)
      .replace(/[【\[][^\]]+[\]】]:?\s*/g, '')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function parseBracketBlocks(text) {
    var cleaned = cleanMarketingText(text);
    var re = /[【\[]([^\]]+)[\]】]:?\s*/g;
    var hits = [];
    var match;
    while ((match = re.exec(cleaned)) !== null) {
      hits.push({ name: match[1].trim(), index: match.index, valStart: match.index + match[0].length });
    }
    if (hits.length < 2) return null;

    var rows = [];
    for (var i = 0; i < hits.length; i += 1) {
      var end = i + 1 < hits.length ? hits[i + 1].index : cleaned.length;
      var value = cleaned.slice(hits[i].valStart, end).replace(/^:\s*/, '').trim();
      if (value) {
        rows.push({ name: titleCaseLabel(hits[i].name), value: value });
      }
    }
    if (rows.length < 2) return null;

    var lead = cleaned.slice(0, hits[0].index).replace(/[?:]\s*$/, '').trim();
    return {
      sectionTitle: "Why You'll Love It",
      lead: lead,
      rows: rows
    };
  }

  function parseLabelBody(text) {
    var cleaned = cleanMarketingText(text);
    var match = cleaned.match(/^(.{6,80}?):\s*(.+)$/);
    if (!match) return null;
    return { name: match[1].trim(), body: match[2].trim() };
  }

  function parseProseFeatureBlocks(text) {
    var cleaned = cleanMarketingText(text);
    var labelRe = /(?:^|\s)([A-Z][^:]{4,80}?):\s+/g;
    var hits = [];
    var match;
    while ((match = labelRe.exec(cleaned)) !== null) {
      var label = match[1].trim();
      if (label.split(/\s+/).length > 10) continue;
      hits.push({
        name: label,
        labelStart: match.index,
        valStart: match.index + match[0].length
      });
    }
    if (hits.length < 2) return null;

    var rows = [];
    for (var i = 0; i < hits.length; i += 1) {
      var end = i + 1 < hits.length ? hits[i + 1].labelStart : cleaned.length;
      var value = cleaned.slice(hits[i].valStart, end).trim();
      if (hits[i].name && value) {
        rows.push({ name: titleCaseLabel(hits[i].name), value: value });
      }
    }
    return rows.length >= 2 ? rows : null;
  }

  function parseMarketingBlocks(text) {
    var cleaned = cleanMarketingText(text);
    var bracketMatch = cleaned.match(/[【\[]([^\]]+)[\]】]/);
    var sectionTitle = bracketMatch ? bracketMatch[1].trim() : '';
    if (bracketMatch) {
      cleaned = cleaned.replace(/[【\[][^\]]+[\]】]\s*/, '').trim();
    }

    var labelRe = /([A-Z][A-Z0-9\s/&'()-]{2,48}):\s*/g;
    var hits = [];
    var match;
    while ((match = labelRe.exec(cleaned)) !== null) {
      var label = match[1].trim();
      var letters = label.replace(/[^a-zA-Z]/g, '');
      var caps = (label.match(/[A-Z]/g) || []).length;
      if (letters.length >= 3 && caps / letters.length >= 0.65) {
        hits.push({ name: label, index: match.index, valStart: match.index + match[0].length });
      }
    }
    if (hits.length < 2) return null;

    var rows = [];
    for (var i = 0; i < hits.length; i += 1) {
      var end = i + 1 < hits.length ? hits[i + 1].index : cleaned.length;
      var value = cleaned.slice(hits[i].valStart, end).trim();
      value = value.replace(/\s+\d+\s+density(\s+\d+\s+density)*\s*$/i, '').trim();
      if (value) {
        rows.push({ name: titleCaseLabel(hits[i].name), value: value });
      }
    }
    if (rows.length < 2) return null;

    var lead = cleaned.slice(0, hits[0].index).replace(/[?:]\s*$/, '').trim();
    return {
      sectionTitle: sectionTitle || "Why You'll Love It",
      lead: lead,
      rows: rows
    };
  }

  function buildMarketingSection(blocks) {
    var frag = document.createDocumentFragment();
    var heading = document.createElement('h3');
    heading.textContent = blocks.sectionTitle;
    frag.appendChild(heading);

    if (blocks.lead) {
      var lead = document.createElement('p');
      lead.className = 'q-pdp-desc-lead';
      lead.textContent = blocks.lead;
      frag.appendChild(lead);
    }

    var list = document.createElement('ul');
    list.className = 'q-pdp-feature-cards';
    blocks.rows.forEach(function (row, idx) {
      var content = resolveFeatureContent(row.name, row.value);
      var li = document.createElement('li');
      li.className = 'q-pdp-feature-card';
      li.innerHTML =
        '<span class="q-pdp-feature-card__num">' +
        String(idx + 1).padStart(2, '0') +
        '</span>' +
        '<div class="q-pdp-feature-card__content">' +
        '<p class="q-pdp-feature-card__title">' +
        escapeDescHtml(content.title) +
        '</p>' +
        '<div class="q-pdp-feature-card__text">' +
        formatFeatureValue(content.body) +
        '</div>' +
        '</div>';
      list.appendChild(li);
    });
    frag.appendChild(list);
    return frag;
  }

  function convertMarketingParagraph(p) {
    if (!p || p.querySelector('img, video, iframe')) return false;
    var text = (p.textContent || '').replace(/\s+/g, ' ').trim();
    if (!text || text.length < 80) return false;
    var blocks = parseMarketingBlocks(text);
    if (!blocks) blocks = parseBracketBlocks(text);
    if (!blocks) {
      var proseRows = parseProseFeatureBlocks(text);
      if (proseRows) {
        blocks = {
          sectionTitle: "Why You'll Love It",
          lead: '',
          rows: proseRows
        };
      }
    }
    if (!blocks) return false;
    p.replaceWith(buildMarketingSection(blocks));
    return true;
  }

  function parseInlineSpecPairs(text) {
    var cleaned = (text || '').replace(/\s+/g, ' ').trim();
    cleaned = cleaned.replace(/^Description\s*:?\s*/i, '').trim();
    if (!cleaned) return null;

    var re = /\b([A-Z][a-z]+(?:\s+[A-Z][a-z]+){0,2}):\s*/g;
    var hits = [];
    var match;
    while ((match = re.exec(cleaned)) !== null) {
      hits.push({ name: match[1].trim(), index: match.index, valStart: match.index + match[0].length });
    }
    if (hits.length < 3) return null;

    var rows = [];
    for (var i = 0; i < hits.length; i += 1) {
      var end = i + 1 < hits.length ? hits[i + 1].index : cleaned.length;
      var value = cleaned.slice(hits[i].valStart, end).trim();
      var name = hits[i].name;
      if (!name || !value || value.length < 2) continue;
      if (name.length > 28 || name.split(/\s+/).length > 4) continue;
      if (value.split(/\s+/).length > 10) continue;
      rows.push({ name: name, value: value });
    }
    return rows.length >= 3 ? rows : null;
  }

  function buildSpecGrid(rows) {
    var grid = document.createElement('dl');
    grid.className = 'q-pdp-spec-grid';
    rows.forEach(function (row) {
      var item = document.createElement('div');
      item.className = 'q-pdp-spec-grid__item';
      item.innerHTML = '<dt>' + row.name + '</dt><dd>' + row.value + '</dd>';
      grid.appendChild(item);
    });
    return grid;
  }

  function escapeDescHtml(text) {
    return String(text || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function smartFeatureTitle(label, value) {
    label = (label || '').trim();
    value = (value || '').trim();
    if (label && !/^Feature\s*\d+$/i.test(label)) return label;
    var colonMatch = value.match(/^(.{12,72}?):\s+/);
    if (colonMatch) return colonMatch[1].trim();
    var sentMatch = value.match(/^(.{24,90}?[.!?])/);
    if (sentMatch) return sentMatch[1].trim();
    var num = (label.match(/\d+/) || ['1'])[0];
    return 'Highlight ' + num;
  }

  function normalizeFeatureText(text) {
    return cleanMarketingText(text)
      .toLowerCase()
      .replace(/[^\w\s]/g, '')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function stripFeatureLead(title, value) {
    value = cleanMarketingText(value);
    title = (title || '').trim();
    if (!value || !title) return value;

    var lowerVal = value.toLowerCase();
    var lowerTitle = title.toLowerCase();
    if (lowerVal.indexOf(lowerTitle) === 0) {
      var rest = value.slice(title.length).replace(/^[\s:.\-–—]+/, '').trim();
      if (rest) return rest;
    }

    var firstSent = value.match(/^(.+?[.!?])\s+/);
    if (firstSent) {
      var sentNorm = normalizeFeatureText(firstSent[1]);
      var titleNorm = normalizeFeatureText(title);
      if (
        sentNorm === titleNorm ||
        sentNorm.indexOf(titleNorm) === 0 ||
        titleNorm.indexOf(sentNorm) === 0
      ) {
        return value.slice(firstSent[0].length).trim();
      }
    }

    return value;
  }

  function resolveFeatureContent(name, value) {
    var title = smartFeatureTitle(name, value);
    var body = stripFeatureLead(title, value);
    if (!body) body = cleanMarketingText(value);
    return { title: title, body: body };
  }

  function isNarrativeRow(label, value) {
    return /^Feature\s*\d+$/i.test(label) || (value && value.length > 100);
  }

  function buildFeatureCards(rows) {
    var list = document.createElement('ul');
    list.className = 'q-pdp-feature-cards';
    rows.forEach(function (row, idx) {
      var content = resolveFeatureContent(row.name, row.value);
      var li = document.createElement('li');
      li.className = 'q-pdp-feature-card';
      li.innerHTML =
        '<span class="q-pdp-feature-card__num">' +
        String(idx + 1).padStart(2, '0') +
        '</span>' +
        '<div class="q-pdp-feature-card__content">' +
        '<p class="q-pdp-feature-card__title">' +
        escapeDescHtml(content.title) +
        '</p>' +
        '<div class="q-pdp-feature-card__text">' +
        formatFeatureValue(content.body) +
        '</div>' +
        '</div>';
      list.appendChild(li);
    });
    return list;
  }

  function parseTableRows(table) {
    var rows = [];
    table.querySelectorAll('tr').forEach(function (tr) {
      var cells = tr.querySelectorAll('td, th');
      if (cells.length < 2) return;
      var name = (cells[0].textContent || '').replace(/\s+/g, ' ').trim();
      var value = (cells[1].textContent || '').replace(/\s+/g, ' ').trim();
      if (name && value) rows.push({ name: name, value: value });
    });
    return rows;
  }

  function normalizeSectionTitle(text) {
    var t = (text || '').trim().toLowerCase();
    if (t === 'specifications' || t === 'key features' || t === 'overview') {
      return '';
    }
    return text;
  }

  function convertHighlightsList(list) {
    var rows = [];
    list.querySelectorAll(':scope > li').forEach(function (li) {
      var strong = li.querySelector('strong');
      var title = strong ? strong.textContent.trim() : '';
      var body = (li.textContent || '').replace(/\s+/g, ' ').trim();
      if (strong) {
        body = body.replace(title, '').trim();
      }
      if (!body && title) body = title;
      if (body) rows.push({ name: title, value: body });
    });
    if (!rows.length) return null;
    return buildFeatureCards(rows);
  }

  function convertTable(table) {
    var rows = parseTableRows(table);
    if (!rows.length) return null;

    var narrative = [];
    var compact = [];
    rows.forEach(function (row) {
      if (isNarrativeRow(row.name, row.value)) {
        narrative.push(row);
      } else {
        compact.push(row);
      }
    });

    var wrap = document.createDocumentFragment();
    if (narrative.length) wrap.appendChild(buildFeatureCards(narrative));
    if (compact.length) wrap.appendChild(buildSpecGrid(compact));
    return wrap.childNodes.length ? wrap : null;
  }

  function restructurePdpDescription() {
    var description = document.querySelector('.q-pdp__description');
    if (!description || description.dataset.qDescRestructured === '1') return;

    description.querySelectorAll('p.q-pdp-desc-overview, .q-pdp-desc-section__body > p:not(:has(> img))').forEach(function (p) {
      convertMarketingParagraph(p);
    });

    description.querySelectorAll('table').forEach(function (table) {
      var replacement = convertTable(table);
      if (replacement) table.replaceWith(replacement);
    });

    description.querySelectorAll('.product-highlights').forEach(function (list) {
      var cards = convertHighlightsList(list);
      if (cards) list.replaceWith(cards);
    });

    description.querySelectorAll('.q-pdp-desc-specs').forEach(function (grid) {
      var rows = [];
      grid.querySelectorAll('.q-pdp-desc-specs__row').forEach(function (row) {
        var name = row.querySelector('.q-pdp-desc-specs__label');
        var value = row.querySelector('.q-pdp-desc-specs__value');
        if (name && value) {
          rows.push({
            name: name.textContent.trim(),
            value: value.textContent.trim()
          });
        }
      });
      if (!rows.length) return;
      var narrative = rows.filter(function (r) {
        return isNarrativeRow(r.name, r.value);
      });
      var compact = rows.filter(function (r) {
        return !isNarrativeRow(r.name, r.value);
      });
      var frag = document.createDocumentFragment();
      if (narrative.length) frag.appendChild(buildFeatureCards(narrative));
      if (compact.length) frag.appendChild(buildSpecGrid(compact));
      grid.replaceWith(frag);
    });

    var headings = description.querySelectorAll(':scope > h3');
    headings.forEach(function (h3) {
      var title = (h3.textContent || '').trim();
      var normalized = normalizeSectionTitle(title);
      if (title.toLowerCase() === 'specifications' && description.querySelector('.q-pdp-feature-cards')) {
        h3.textContent = "Why You'll Love It";
      } else if (title.toLowerCase() === 'key features') {
        h3.textContent = "Why You'll Love It";
      } else if (title.toLowerCase() === 'specifications' && description.querySelector('.q-pdp-spec-grid')) {
        h3.textContent = 'The Details';
      } else if (normalized) {
        h3.textContent = normalized;
      }

      var section = document.createElement('section');
      section.className = 'q-pdp-desc-section';
      h3.parentNode.insertBefore(section, h3);
      section.appendChild(h3);
      h3.className = 'q-pdp-desc-section__title';

      var body = document.createElement('div');
      body.className = 'q-pdp-desc-section__body';
      section.appendChild(body);

      var sibling = section.nextSibling;
      while (sibling) {
        if (sibling.nodeType === 1 && sibling.tagName === 'H3') break;
        if (
          sibling.nodeType === 1 &&
          sibling.classList &&
          sibling.classList.contains('q-pdp-desc-section')
        ) {
          break;
        }
        var next = sibling.nextSibling;
        if (sibling.nodeType === 1 || (sibling.nodeType === 3 && sibling.textContent.trim())) {
          body.appendChild(sibling);
        } else if (sibling.parentNode) {
          sibling.parentNode.removeChild(sibling);
        }
        sibling = next;
      }

      body.querySelectorAll(':scope > p.q-pdp-desc-overview, :scope > p:not(:has(> img))').forEach(function (p) {
        convertMarketingParagraph(p);
      });

      if (body.querySelector('img, video, iframe')) {
        section.classList.add('q-pdp-desc-section--media');
      } else if (body.querySelector('.q-pdp-feature-cards')) {
        section.classList.add('q-pdp-desc-section--features');
      }
    });

    if (description.querySelector('.q-pdp-desc-section--features')) {
      description.querySelectorAll(':scope > p.q-pdp-desc-overview, :scope > p.q-pdp-desc-intro').forEach(function (p) {
        p.remove();
      });
    }

    description.querySelectorAll('.q-pdp-feature-card').forEach(function (card) {
      var titleEl = card.querySelector('.q-pdp-feature-card__title');
      var textEl = card.querySelector('.q-pdp-feature-card__text');
      if (!titleEl || !textEl) return;

      var rawText = cleanMarketingText(textEl.textContent || '');
      if (!rawText) rawText = cleanMarketingText(titleEl.textContent || '');
      if (!rawText) return;

      var bracket = rawText.match(/^[【\[]([^\]]+)[\]】]:?\s*(.*)$/);
      if (bracket) {
        titleEl.textContent = titleCaseLabel(bracket[1].trim());
        var content = resolveFeatureContent('', bracket[2].trim() || rawText);
        textEl.innerHTML = formatFeatureValue(content.body);
        return;
      }

      var parsed = parseLabelBody(rawText);
      var content = parsed
        ? { title: titleCaseLabel(parsed.name), body: parsed.body }
        : resolveFeatureContent(titleEl.textContent || '', rawText);
      titleEl.textContent = content.title;
      textEl.innerHTML = formatFeatureValue(content.body);
    });

    description.dataset.qDescRestructured = '1';
  }

  function enhancePdpDescription() {
    var description = document.querySelector('.q-pdp__description');
    if (!description || description.dataset.qDescEnhanced === '1') return;

    var hasSpecTable = !!description.querySelector('table, .q-pdp-desc-specs');

    description.querySelectorAll(':scope > p').forEach(function (p) {
      if (p.querySelector('img, video, iframe')) return;
      if (p.classList.contains('q-pdp-desc-intro')) return;

      var text = (p.textContent || '').replace(/\s+/g, ' ').trim();
      if (!text) return;

      if (convertMarketingParagraph(p)) return;

      var colonCount = (text.match(/:/g) || []).length;
      var rows = parseInlineSpecPairs(text);
      if (rows) {
        var grid = buildSpecGrid(rows);
        var heading = document.createElement('h3');
        heading.textContent = 'Overview';
        p.replaceWith(heading, grid);
        return;
      }

      if (colonCount >= 4 && hasSpecTable) {
        p.remove();
        return;
      }

      if (colonCount >= 3 && description.querySelector('h3, .q-pdp-feature-cards')) {
        p.remove();
        return;
      }

      if (colonCount >= 3) {
        p.classList.add('q-pdp-desc-overview');
        return;
      }

      if (text.length > 40 && !/[.!?]$/.test(text)) {
        p.classList.add('q-pdp-desc-intro');
      }
    });

    description.dataset.qDescEnhanced = '1';
  }

  window.qEnhancePdpDescription = enhancePdpDescription;

  function runPdpDescriptionEnhancements() {
    collapseEmptyDescriptionBlocks();
    enhancePdpDescription();
    restructurePdpDescription();
  }

  window.qCollapseEmptyDescriptionBlocks = collapseEmptyDescriptionBlocks;

  window.qSyncReviewsSectionVisibility = syncReviewsSectionVisibility;

  /* Keep EZ Amazon Reviews widget inside the reviews host (avoid split layout) */
  function pinEzReviewsBeforeDescription() {
    styleEzReviewUi();
    var description = document.querySelector('.q-pdp__description');
    if (!description) return;

    var host =
      document.querySelector('.q-pdp-reviews__inner') ||
      document.getElementById('aliexpress-review-wrapper-sp');
    if (!host) return;

    var widget =
      document.querySelector('.ez-amrv-wrapp') ||
      document.getElementById('ra-dt-wrpp');
    if (widget && !host.contains(widget)) {
      host.appendChild(widget);
    }

    var reviewsSection = document.querySelector('.q-pdp-reviews');
    if (reviewsSection && description.compareDocumentPosition(reviewsSection) & Node.DOCUMENT_POSITION_FOLLOWING) {
      description.parentNode.insertBefore(reviewsSection, description);
    }
  }

  function watchEzReviewPlacement() {
    pinEzReviewsBeforeDescription();
    if (!document.querySelector('.q-pdp')) return;

    var observer = new MutationObserver(function () {
      pinEzReviewsBeforeDescription();
    });
    observer.observe(document.body, { childList: true, subtree: true });

    var attempts = 0;
    var timer = setInterval(function () {
      pinEzReviewsBeforeDescription();
      attempts += 1;
      if (attempts >= 20) clearInterval(timer);
    }, 500);
  }

  window.addEventListener('load', watchEzReviewPlacement);
  document.addEventListener('DOMContentLoaded', watchEzReviewPlacement);

  /* Wishlist — localStorage + #wishlist panel on homepage */
  var WISHLIST_KEY = 'q_wishlist_v1';
  var wishlistPanel = document.querySelector('[data-q-wishlist-panel]');
  var wishlistGrid = document.querySelector('[data-q-wishlist-grid]');
  var wishlistEmpty = document.querySelector('[data-q-wishlist-empty]');
  var wishlistCount = document.querySelector('[data-q-wishlist-count]');
  var homeSection = document.querySelector('.q-home');

  function readWishlist() {
    try {
      var raw = localStorage.getItem(WISHLIST_KEY);
      var list = raw ? JSON.parse(raw) : [];
      return Array.isArray(list) ? list : [];
    } catch (e) {
      return [];
    }
  }

  function writeWishlist(list) {
    localStorage.setItem(WISHLIST_KEY, JSON.stringify(list));
  }

  function productFromWishButton(btn) {
    return {
      id: String(btn.dataset.productId || ''),
      handle: btn.dataset.productHandle || '',
      title: btn.dataset.productTitle || '',
      url: btn.dataset.productUrl || '',
      image: btn.dataset.productImage || '',
      price: btn.dataset.productPrice || ''
    };
  }

  function syncWishButtons() {
    var ids = readWishlist().map(function (p) {
      return String(p.id);
    });
    document.querySelectorAll('[data-q-wish]').forEach(function (btn) {
      var saved = ids.indexOf(String(btn.dataset.productId || '')) >= 0;
      btn.classList.toggle('is-saved', saved);
      btn.setAttribute('aria-pressed', saved ? 'true' : 'false');
      btn.setAttribute('aria-label', saved ? 'Remove from wishlist' : 'Save to wishlist');
    });
  }

  function renderWishlist() {
    if (!wishlistGrid || !wishlistEmpty) return;
    var list = readWishlist();
    wishlistGrid.innerHTML = '';

    if (list.length === 0) {
      wishlistEmpty.hidden = false;
      if (wishlistCount) wishlistCount.hidden = true;
      return;
    }

    wishlistEmpty.hidden = true;
    if (wishlistCount) {
      wishlistCount.hidden = false;
      wishlistCount.textContent = list.length + (list.length === 1 ? ' item' : ' items');
    }

    list.forEach(function (item) {
      var card = document.createElement('article');
      card.className = 'q-card';
      card.setAttribute('role', 'listitem');
      var imgHtml = item.image
        ? '<img class="q-card__img" src="' + item.image + '" alt="" loading="lazy">'
        : '<div class="q-card__img q-card__img--placeholder"></div>';
      card.innerHTML =
        '<a href="' +
        item.url +
        '" class="q-card__media">' +
        imgHtml +
        '<button type="button" class="q-card__wish is-saved" aria-label="Remove from wishlist" aria-pressed="true" data-q-wish data-product-id="' +
        item.id +
        '" data-product-handle="' +
        (item.handle || '') +
        '" data-product-title="' +
        (item.title || '').replace(/"/g, '&quot;') +
        '" data-product-url="' +
        (item.url || '') +
        '" data-product-image="' +
        (item.image || '') +
        '" data-product-price="' +
        (item.price || '') +
        '"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><path d="M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.6l-1-1a5.5 5.5 0 0 0-7.8 7.8l1 1L12 21l7.8-7.6 1-1a5.5 5.5 0 0 0 0-7.8z"/></svg></button></a>' +
        '<div class="q-card__info"><div class="q-card__row"><h3 class="q-card__title"><a href="' +
        item.url +
        '">' +
        item.title +
        '</a></h3><div class="q-card__price"><span>' +
        item.price +
        '</span></div></div></div>';
      wishlistGrid.appendChild(card);
    });
  }

  function toggleWishlistItem(product) {
    if (!product.id) return;
    var list = readWishlist();
    var idx = list.findIndex(function (p) {
      return String(p.id) === String(product.id);
    });
    if (idx >= 0) {
      list.splice(idx, 1);
    } else {
      list.push(product);
    }
    writeWishlist(list);
    syncWishButtons();
    if (window.location.hash === '#wishlist') renderWishlist();
  }

  function syncWishlistRoute() {
    if (!wishlistPanel) return;
    var show = window.location.hash === '#wishlist';
    wishlistPanel.hidden = !show;
    if (homeSection) homeSection.hidden = show;
    if (show) {
      renderWishlist();
      wishlistPanel.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-q-wish]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    toggleWishlistItem(productFromWishButton(btn));
  });

  window.addEventListener('hashchange', syncWishlistRoute);
  syncWishButtons();
  syncWishlistRoute();
  window.qSyncWishButtons = syncWishButtons;

  /* Recent orders marquee — product page top-left */
  function mountRecentOrdersOnGallery(root) {
    if (!root) return;
    var host =
      document.querySelector('[data-q-recent-orders-slot]') ||
      document.querySelector('.u-pdp__gallery') ||
      document.querySelector('.q-pdp__gallery') ||
      document.querySelector('.u-pdp__stage') ||
      document.querySelector('.q-pdp__stage');
    if (!host) return;
    if (getComputedStyle(host).position === 'static') {
      host.style.position = 'relative';
    }
    if (root.parentElement !== host) host.appendChild(root);
  }

  function bindRecentOrdersScrollHide(root) {
    if (root && root.closest('[data-q-recent-orders-slot], .u-pdp__stage, .q-pdp__stage, .u-pdp__gallery, .q-pdp__gallery')) {
      root.classList.remove('q-recent-orders--hidden');
      return;
    }

    var gallery =
      document.querySelector('.u-pdp__gallery') || document.querySelector('.q-pdp__gallery');
    if (!root || !gallery) return;

    function update() {
      var galleryBottom = gallery.getBoundingClientRect().bottom + window.scrollY - 72;
      if (window.scrollY > galleryBottom) {
        root.classList.add('q-recent-orders--hidden');
      } else {
        root.classList.remove('q-recent-orders--hidden');
      }
    }

    window.addEventListener('scroll', update, { passive: true });
    update();
  }

  function initRecentOrdersMarquee() {
    var root = document.querySelector('[data-q-recent-orders]');
    if (!root) return;
    mountRecentOrdersOnGallery(root);

    var feedUrl = root.getAttribute('data-feed-url');
    var productHandle = root.getAttribute('data-product-handle') || '';
    var isProductPage = document.body.classList.contains('q-template-product');
    if (!isProductPage) return;

    bindRecentOrdersScrollHide(root);

    var track = root.querySelector('[data-q-recent-track]');
    if (!track) return;

    function resolveCreatedAt(item) {
      if (item.seconds_ago != null && item.seconds_ago !== '') {
        return new Date(Date.now() - Number(item.seconds_ago) * 1000).toISOString();
      }
      return item.created_at || '';
    }

    function normalizeFeed(feed) {
      if (!Array.isArray(feed)) return [];
      return feed.map(function (item) {
        var copy = Object.assign({}, item);
        copy.created_at = resolveCreatedAt(copy);
        return copy;
      });
    }

    function formatTimeAgo(iso) {
      if (!iso) return '';
      var diff = Date.now() - new Date(iso).getTime();
      if (diff < 0) diff = 0;
      var secs = Math.floor(diff / 1000);
      if (secs < 60) return secs + ' sec ago';
      var mins = Math.floor(secs / 60);
      if (mins === 1) return '1 min ago';
      if (mins < 60) return mins + ' min ago';
      var hrs = Math.floor(mins / 60);
      if (hrs === 1) return '1 hr ago';
      if (hrs < 24) return hrs + ' hr ago';
      var days = Math.floor(hrs / 24);
      return days === 1 ? '1 day ago' : days + ' days ago';
    }

    function syncItemTimestamp(node) {
      var secondsAgo = node.getAttribute('data-seconds-ago');
      if (secondsAgo != null && secondsAgo !== '') {
        node.setAttribute('data-created-at', resolveCreatedAt({ seconds_ago: secondsAgo }));
      }
    }

    function updateTimes() {
      root.querySelectorAll('[data-q-recent-item]').forEach(function (node) {
        syncItemTimestamp(node);
        var timeEl = node.querySelector('[data-q-recent-time]');
        if (timeEl) {
          timeEl.textContent = formatTimeAgo(node.getAttribute('data-created-at'));
        }
      });
    }

    function buildItem(item) {
      var createdAt = resolveCreatedAt(item);
      var el = document.createElement('div');
      el.className = 'q-recent-orders__item';
      el.setAttribute('data-q-recent-item', '');
      el.setAttribute('data-created-at', createdAt);
      if (item.seconds_ago != null && item.seconds_ago !== '') {
        el.setAttribute('data-seconds-ago', String(item.seconds_ago));
      }

      var location = '';
      if (item.city) {
        location = ' from ' + item.city;
        if (item.state) location += ', ' + item.state;
      }

      el.innerHTML =
        '<span class="q-recent-orders__dot" aria-hidden="true"></span>' +
        '<div class="q-recent-orders__content">' +
        '<span class="q-recent-orders__text"><strong>' +
        (item.name || 'Someone') +
        '</strong>' +
        location +
        ' ordered ' +
        (item.product_title || '') +
        '</span>' +
        '<span class="q-recent-orders__time" data-q-recent-time></span>' +
        '</div>';

      var timeEl = el.querySelector('[data-q-recent-time]');
      if (timeEl) timeEl.textContent = formatTimeAgo(createdAt);
      return el;
    }

    function pickItems(feed) {
      if (!isProductPage || !productHandle) return feed.slice(0, 18);
      var matched = feed.filter(function (item) {
        return item.product_handle && item.product_handle === productHandle;
      });
      var others = feed.filter(function (item) {
        return !(item.product_handle && item.product_handle === productHandle);
      });
      return matched.concat(others).slice(0, 18);
    }

    function startRecentOrdersTicker() {
      var viewport = root.querySelector('.q-recent-orders__viewport');
      if (!viewport) return;

      var pauseMs = 4000;
      var transitionMs = 450;
      var index = 0;
      var offsets = [];
      var viewportHeight = 0;
      var tickerId = null;
      var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      function getItems() {
        return track.querySelectorAll('[data-q-recent-item]');
      }

      function measure() {
        var items = getItems();
        if (!items.length) return 0;

        offsets = [];
        viewportHeight = 0;
        var total = 0;

        items.forEach(function (el, i) {
          offsets[i] = total;
          var h = el.offsetHeight;
          viewportHeight = Math.max(viewportHeight, h);
          total += h;
        });

        viewport.style.height = viewportHeight + 'px';
        return items.length;
      }

      function setPosition(nextIndex, animate) {
        var y = offsets[nextIndex] || 0;
        track.style.transition = animate ? 'transform ' + transitionMs / 1000 + 's ease' : 'none';
        track.style.transform = 'translateY(-' + y + 'px)';
      }

      function prepareLoopClone() {
        var items = getItems();
        if (!items.length) return;
        track.querySelectorAll('[data-q-recent-clone]').forEach(function (node) {
          node.remove();
        });
        if (items.length === 1) return;
        var clone = items[0].cloneNode(true);
        clone.setAttribute('data-q-recent-clone', '');
        clone.setAttribute('aria-hidden', 'true');
        track.appendChild(clone);
      }

      function tick() {
        var items = getItems();
        if (items.length <= 1) return;

        if (index >= items.length - 1) {
          index = 0;
          setPosition(0, false);
          return;
        }

        index += 1;
        setPosition(index, true);
      }

      function start() {
        if (tickerId) {
          clearInterval(tickerId);
          tickerId = null;
        }

        index = 0;
        track.style.transform = 'translateY(0)';
        track.style.transition = 'none';

        var count = measure();
        if (!count) return;

        prepareLoopClone();
        measure();
        setPosition(0, false);

        if (count === 1 || reducedMotion) return;

        tickerId = setInterval(tick, pauseMs);
      }

      start();
      window.addEventListener('resize', function () {
        measure();
        setPosition(index, false);
      });
    }

    function renderFeed(feed) {
      feed = normalizeFeed(feed);
      if (!Array.isArray(feed) || feed.length === 0) return false;

      var items = pickItems(feed);
      if (!items.length) return false;

      track.innerHTML = '';
      items.forEach(function (item) {
        track.appendChild(buildItem(item));
      });

      root.hidden = false;
      root.classList.remove('q-recent-orders--pending');
      updateTimes();
      setInterval(updateTimes, 60000);
      startRecentOrdersTicker();
      return true;
    }

    /* Server-rendered from shop metafield */
    if (track.querySelector('[data-q-recent-item]')) {
      root.hidden = false;
      root.classList.remove('q-recent-orders--pending');
      updateTimes();
      setInterval(updateTimes, 60000);
      startRecentOrdersTicker();
      return;
    }

    if (!feedUrl) return;

    fetch(feedUrl, { credentials: 'same-origin' })
      .then(function (res) {
        if (!res.ok) throw new Error('feed load failed');
        return res.json();
      })
      .then(function (feed) {
        if (!renderFeed(feed)) {
          root.hidden = true;
        }
      })
      .catch(function () {
        root.hidden = true;
      });
  }

  initRecentOrdersMarquee();

  /* Cart page — Quince shopping bag */
  function initCartPage() {
    var cartRoot = document.querySelector('[data-q-cart]');
    if (!cartRoot) return;

    var moneyFormat = cartRoot.getAttribute('data-money-format') || '${{amount}}';

    function formatMoney(cents) {
      if (window.Shopify && typeof Shopify.formatMoney === 'function') {
        return Shopify.formatMoney(cents, moneyFormat);
      }
      return '$' + (cents / 100).toFixed(2);
    }

    function updateHeaderCartCount(count) {
      document.querySelectorAll('.q-header__cart-count, .q-drawer__cart-count').forEach(function (el) {
        if (count > 0) {
          el.textContent = count;
          el.hidden = false;
        } else {
          el.hidden = true;
        }
      });
    }

    function setQtyDownIcon(btn, qty) {
      if (!btn) return;
      if (qty <= 1) {
        btn.innerHTML =
          '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><path d="M3 6h18M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2m3 0v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6h14z"/></svg>';
        btn.setAttribute('aria-label', 'Remove item');
      } else {
        btn.innerHTML = '<span aria-hidden="true">−</span>';
        btn.setAttribute('aria-label', 'Decrease quantity');
      }
    }

    function updateLinePrices(line, item) {
      var compareEl = line.querySelector('[data-q-cart-line-compare]');
      var priceEl = line.querySelector('[data-q-cart-line-price]');
      var compareUnit = parseInt(line.getAttribute('data-compare-unit'), 10) || 0;
      var compareLine = 0;
      var showCompare = false;

      if (compareUnit > item.final_price) {
        compareLine = compareUnit * item.quantity;
        showCompare = true;
      } else if (item.original_line_price > item.final_line_price) {
        compareLine = item.original_line_price;
        showCompare = true;
      }

      if (compareEl) {
        compareEl.hidden = !showCompare;
        if (showCompare) compareEl.textContent = formatMoney(compareLine);
      }
      if (priceEl) priceEl.textContent = formatMoney(item.final_line_price);
    }

    function findCartLine(itemKey, variantId) {
      var lines = cartRoot.querySelectorAll('.q-cart__item[data-line-key]');
      var keyStr = itemKey != null ? String(itemKey) : '';
      var i;
      for (i = 0; i < lines.length; i++) {
        if (lines[i].getAttribute('data-line-key') === keyStr) return lines[i];
      }
      if (variantId != null) {
        var variantStr = String(variantId);
        for (i = 0; i < lines.length; i++) {
          if (lines[i].getAttribute('data-variant-id') === variantStr) return lines[i];
        }
      }
      return null;
    }

    function cartSubtotal(cart) {
      if (typeof cart.items_subtotal_price === 'number') return cart.items_subtotal_price;
      if (!Array.isArray(cart.items)) return 0;
      return cart.items.reduce(function (sum, item) {
        return sum + (item.final_line_price || 0);
      }, 0);
    }

    function applyCartResponse(cart) {
      if (!cart || !Array.isArray(cart.items)) {
        window.location.reload();
        return;
      }

      var subtotalEl = cartRoot.querySelector('[data-q-cart-subtotal]');
      if (subtotalEl) subtotalEl.textContent = formatMoney(cartSubtotal(cart));

      var totalRow = cartRoot.querySelector('[data-q-cart-total-row]');
      var totalEl = cartRoot.querySelector('[data-q-cart-total]');
      var hasCartDiscount =
        cart.cart_level_discount_applications && cart.cart_level_discount_applications.length > 0;

      if (totalRow) totalRow.hidden = !hasCartDiscount;
      if (totalEl && hasCartDiscount) totalEl.textContent = formatMoney(cart.total_price);

      cartRoot.querySelectorAll('[data-q-cart-discount]').forEach(function (row) {
        row.remove();
      });
      if (hasCartDiscount && subtotalEl) {
        var summary = subtotalEl.closest('.q-cart__summary');
        var shippingRow = cartRoot.querySelector('.q-cart__shipping-free');
        var anchor = totalRow || (shippingRow && shippingRow.closest('.q-cart__summary-row'));
        cart.cart_level_discount_applications.forEach(function (discount) {
          var amount = discount.total_allocated_amount || 0;
          var row = document.createElement('div');
          row.className = 'q-cart__summary-row q-cart__summary-row--discount';
          row.setAttribute('data-q-cart-discount', '');
          row.innerHTML =
            '<span>' +
            (discount.title || 'Discount') +
            '</span><span>-' +
            formatMoney(amount) +
            '</span>';
          if (summary && anchor) summary.insertBefore(row, anchor);
        });
      }

      updateHeaderCartCount(cart.item_count);

      var keys = Object.create(null);
      cart.items.forEach(function (item) {
        if (item.key == null) return;
        keys[String(item.key)] = item;
      });

      cart.items.forEach(function (item) {
        var line = findCartLine(item.key, item.variant_id || item.id);
        if (!line) return;
        var qtyVal = line.querySelector('[data-q-cart-qty-value]');
        var qtyWrap = line.querySelector('[data-q-cart-qty]');
        var downBtn = line.querySelector('[data-q-cart-qty-down]');
        if (item.key != null) line.setAttribute('data-line-key', String(item.key));
        if (qtyVal) qtyVal.textContent = item.quantity;
        updateLinePrices(line, item);
        if (qtyWrap) qtyWrap.setAttribute('data-qty', item.quantity);
        setQtyDownIcon(downBtn, item.quantity);
      });

      cartRoot.querySelectorAll('.q-cart__item[data-line-key]').forEach(function (lineEl) {
        var lineKey = lineEl.getAttribute('data-line-key');
        if (!lineKey || !keys[lineKey]) lineEl.remove();
      });

      if (cart.item_count === 0) {
        window.location.reload();
      }
    }

    function changeLine(key, quantity) {
      if (!key) return Promise.reject(new Error('missing line key'));
      return qShopifyFetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ id: String(key), quantity: quantity })
      })
        .then(function (res) {
          if (!res.ok) throw new Error('cart change failed');
          return res.json();
        })
        .then(applyCartResponse)
        .catch(function () {
          window.location.reload();
        });
    }

    cartRoot.addEventListener('click', function (e) {
      var upBtn = e.target.closest('[data-q-cart-qty-up]');
      var downBtn = e.target.closest('[data-q-cart-qty-down]');
      var saveBtn = e.target.closest('[data-q-cart-save]');
      var line = e.target.closest('.q-cart__item');
      if (!line) return;

      var key = line.getAttribute('data-line-key');
      var qtyWrap = line.querySelector('[data-q-cart-qty]');
      var qty = parseInt(qtyWrap && qtyWrap.getAttribute('data-qty'), 10) || 1;

      if (upBtn) {
        e.preventDefault();
        changeLine(key, qty + 1);
        return;
      }

      if (downBtn) {
        e.preventDefault();
        changeLine(key, Math.max(0, qty - 1));
        return;
      }

      if (saveBtn) {
        e.preventDefault();
        e.stopPropagation();
        toggleWishlistItem({
          id: line.getAttribute('data-product-id') || '',
          handle: line.getAttribute('data-product-handle') || '',
          title: line.getAttribute('data-product-title') || '',
          url: line.getAttribute('data-product-url') || '',
          image: line.getAttribute('data-product-image') || '',
          price: line.getAttribute('data-product-price') || ''
        });
        saveBtn.textContent = 'Saved ✓';
        saveBtn.disabled = true;
        return;
      }
    });
  }

  initCartPage();

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || !form.classList || !form.classList.contains('q-card__atc-form')) return;
    event.preventDefault();
    var idInput = form.querySelector('[name="id"]');
    var submitBtn = form.querySelector('[type="submit"]');
    if (!idInput) return;
    var variantId = parseInt(idInput.value, 10);
    if (!variantId) return;
    if (submitBtn) submitBtn.disabled = true;

    qShopifyFetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('add failed');
        return res.json();
      })
      .then(function (item) {
        var variant = {
          id: variantId,
          price: item && item.price != null ? item.price : 0
        };
        var card = form.closest('[data-product-id]');
        var title = card ? card.getAttribute('data-product-title') : '';
        qTrackMetaAddToCart(variant, title);
        window.location.href = '/cart';
      })
      .catch(function () {
        if (submitBtn) submitBtn.disabled = false;
        form.submit();
      });
  });
})();
